export default __webpack_public_path__ + "static/media/star-white.b1d5da0f.svg";